import {PROPERTY_SELECTOR_SIGIL} from '../constants';
import {isEqual} from '@servicenow/ui-utils';

/**
 * function to remove the entry from the resolvedSelectedPropertyMapping
 * 1. remove the entry if found
 * 2. If the entry to be deleted has impacted consumer components, those impacted ones will be cleared too
 * @param resolvedMappings
 * @param selectedMappings
 * @returns {(function(*, *, *): void)|*}
 */
export default (resolvedMappings, selectedMappings) =>
	function removeResolvedPropertyMapping(providerId, providerPropName, newValue) {
		if (providerId && providerPropName) {
			const selectorKey = `${providerId}${PROPERTY_SELECTOR_SIGIL}${providerPropName}`;
			if (selectorKey || resolvedMappings.has(selectorKey)) {
				if (!isEqual(newValue, resolvedMappings.get(selectorKey))) {
					resolvedMappings.delete(selectorKey);
					deleteImpactedMapping(selectedMappings, selectorKey, resolvedMappings);
				}
			}
		}
	};

// need to clear cached values for selectable consumer values down the chain
function deleteImpactedMapping(selectedMappings, selectorKey, resolvedMappings) {
	const impactedMappings = selectedMappings[selectorKey];
	if (!impactedMappings) return;

	for (const impactedMappingKey in impactedMappings) {
		resolvedMappings.delete(impactedMappingKey);
		deleteImpactedMapping(selectedMappings, impactedMappingKey, resolvedMappings);
	}
}
